/* BUTTON IN THE NAVIGATIONO BAR */
import React from "react";
import SearchIcon from "@material-ui/icons/Search";
import { alpha, makeStyles } from "@material-ui/core/styles";
import { styled } from "../styled";
import { InputBase } from "@material-ui/core";
import { theme as themeStyle } from "../theme";

const useStyles = makeStyles((theme) => ({
	grow: {
		flexGrow: 1,
	},
	search: {
		display: "flex",
		flexDirection: "reverse-row",
		justifyContent: "flex-start",
		position: "relative",
		maxHeight: "30px",
		borderRadius: 0,
		// marginRight: theme.spacing(2),
		marginLeft: 0,
		[theme.breakpoints.up("sm")]: {
			//marginLeft: theme.spacing(3),
			width: "auto",
		},
	},
	searchIcon: {
		padding: theme.spacing(0.5, 2),
		height: "100%",
		maxWidth: "100%",
		position: "relative",
		pointerEvents: "none",
		display: "flex",
		color: themeStyle.colors.mainGreen.main,
		zIndex: 1,
		alignItems: "center",
		justifyContent: "flex-start",
	},
	inputRoot: {
		color: themeStyle.colors.mainGreen.main,
	},
	inputInput: {
		padding: theme.spacing(1, 1, 1, 2),
		// vertical padding + font size from searchIcon
		transition: theme.transitions.create("width"),
		width: "100%",
		color: themeStyle.colors.mainGreen.main,
		[theme.breakpoints.up("md")]: {
			width: "20ch",
		},
	},
	sectionDesktop: {
		display: "none",
		[theme.breakpoints.up("md")]: {
			display: "flex",
		},
	},
	sectionMobile: {
		display: "flex",
		[theme.breakpoints.up("md")]: {
			display: "none",
		},
	},
}));

const SearchContainer = styled(InputBase)({
	height: "100%",
	maxHeight: "30px",
	width: "100%",
	borderBottomStyle: "20",
	borderRadius: 20,
	borderColor: themeStyle.colors.mainGreen.main,
	color: themeStyle.colors.mainGreen.main,
	/*Angle shapes for the buttons*/
	border: "1px solid",
});

const SpSearch = ({ text, onChange, value, searchStyle, iconStyle }) => {
	const classes = useStyles();

	return (
		<div className={classes.search}>
			<div className={classes.searchIcon} style={{ ...iconStyle }}>
				<SearchIcon fontSize='medium' />
			</div>
			<SearchContainer
				placeholder='Cerca…'
				style={{ ...searchStyle }}
				onChange={(e) => onChange(e)}
				value={value}
				classes={{
					root: { ...classes.inputRoot, ...searchStyle },
					input: classes.inputInput,
				}}
				inputProps={{ "aria-label": "search" }}
			/>
		</div>
	);
};

export default SpSearch;
